<ifr-page-title pageTitle="'REPORTS_TITLE' | translate "/>
<section data-widget-grid id="reports-view">
    <reports lic-key="licKey" />
    <iflx-scroll-up-directive></iflx-scroll-up-directive>
  </section>
